import { writable } from 'svelte/store';

export const name = writable('');
export const mmti = writable('');

// default: INFP
// 동의 (-2) VS 미동의 (+2)
// mmti_{+}{-}
// - mmti_ei
// - mmti_ns
// - mmti_ft
// - mmti_pj

export const pv = writable(0);
export const mmti_dict = writable({});

//export const mmti_dict = writable({
//    "mmti1": "0",
//    "mmti2": "0",
//    "mmti3": "0",
//    "mmti4": "0",
//    "mmti5": "0",
//    "mmti6": "0",
//    "mmti7": "0",
//    "mmti8": "0",
//    "mmti9": "0",
//    "mmti10": "0",
//    "mmti11": "0",
//    "mmti12": "0",
//    "mmti13": "0",
//    "mmti14": "0",
//    "mmti15": "0",
//    "mmti16": "0",
//    "mmti17": "0",
//    "mmti18": "0",
//    "mmti19": "0",
//    "mmti20": "0",
//    "mmti21": "0",
//    "mmti22": "0",
//    "mmti23": "0",
//    "mmti24": "0",
//    "mmti25": "0",
//    "mmti26": "0",
//    "mmti27": "0",
//    "mmti28": "0",
//    "mmti29": "0",
//    "mmti30": "0",
//    "mmti31": "0",
//    "mmti32": "0",
//    "mmti33": "0",
//    "mmti34": "0",
//    "mmti35": "0",
//    "mmti36": "0",
//    "mmti37": "0",
//    "mmti38": "0",
//    "mmti39": "0",
//    "mmti40": "0"
//});
